import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export type CBQQuestionType =
  | "mcq"
  | "multi_response"
  | "drag_drop_ordering"
  | "drag_drop_classification"
  | "dropdown"
  | "numeric";

export interface CBQChoice {
  key: string;
  text: string;
}

// optionsJson / correctAnswerJson are shaped per `type` (see editors). Kept
// loose here; the type-specific editors own the concrete shapes and casting.
export interface CBQQuestionDTO {
  id: string;
  scenarioId?: string;
  // Fractional-index position, rewritten on every insert/reorder. `order` is
  // only backfilled at publish time, so drafts must be sorted on this.
  sortKey?: string | null;
  order?: number | null;
  type: CBQQuestionType;
  prompt: string | null;
  helpText: string | null;
  optionsJson: Record<string, unknown> | null;
  correctAnswerJson: Record<string, unknown> | null;
  points: number | null;
  status?: string;
  // Server-side authoring validation hints.
  completeness?: number;
  warnings?: string[];
  blockers?: string[];
  createdAt?: string;
  updatedAt?: string;
}

type InitCBQQuestionResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: CBQQuestionDTO;
};

export const InitCBQQuestion = async (
  scenarioId: string,
  type: CBQQuestionType
): Promise<InitCBQQuestionResponse> => {
  try {
    const response = await axios.post(
      `/admin/cbq/scenarios/${scenarioId}/questions/init`,
      { type }
    );
    return { data: response.data?.data ?? response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
